import React, {Component} from "react";
import PropTypes from 'prop-types';
import shortid from 'shortid';

import {XDiv, XLabel,XI} from "../Layout/Layout";
import Eventer from "../Event/Eventer";
import EventManager from "../Event/EventManager";

class  CheckBox extends Component{

    constructor(props) {
        super(props);
        this.input=React.createRef();

        this.id=shortid.generate();

        this.Hclick = this.click.bind(this);
        this.HonChange = this.onChange.bind(this);

        let checked=false;
        if(props.checked==="checked") checked=true;
        this.state = {checked:checked};

        this.isAlive = true;
        this.event = new EventManager();

        this.props=props;
    }

    onChange(event) {
        event.preventDefault();
        event.stopPropagation();
        let checked=event.target.checked;
        this.setState({checked: checked});
        return false;
    }

    componentDidMount() {
        if(this.props.onChange) {
            this.event.bind(this.input.current, 'change', this.props.onChange, false);
        }
        this.event.bind(this.input.current, 'change', this.HonChange , false);
    }

    click(evt) {
        if(this.state.checked){
            this.input.current.checked=false;
        }else{
            this.input.current.checked=true;
        }
        Eventer.triggerEvent( this.input.current,"change");
        evt.preventDefault();
        evt.stopPropagation();
        return false;
    }

    setChecked(trigger=true) {
        this.setState({checked: true});
        if(trigger) {
            Eventer.triggerEvent( this.input.current,"change");
        }
    }

    setUnChecked(trigger=true) {
        this.setState({checked: false});
        if(trigger) {
            Eventer.triggerEvent( this.input.current,"change");
        }
    }

    render() {
        const {
            className,
            labelClass,
            children,
            value
        } = this.props;

        let c;
        let cI="";
        if(this.state.checked){
            c=`checkbox  ${className} checked`;
            cI="la la-check";
        }else {
            c=`checkbox  ${className} unChecked`;
        }

        let label;
        if(this.props.hasLabel){
            label=<XLabel htmlFor={this.id} onClick={this.Hclick} className={labelClass}>{children}</XLabel>
        }

        return (
            <React.Fragment>
                <XDiv className={c} onClick={this.Hclick}>
                    <input ref={this.input}   id={this.id}  className="hidden-checkbox"  value={value} onChange={this.HonChange}  checked={this.state.checked}  type="checkbox"  />
                    <XI className={cI} />
                </XDiv>
                {label}
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }
        this.event.unbindAll();
        this.isAlive = false;
    }
}

CheckBox.propTypes = {
    className: PropTypes.string,
    labelClass: PropTypes.string,
    checked: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    value:PropTypes.string,
    hasLabel: PropTypes.bool,
};

CheckBox.defaultProps = {
    className:"checkbox-default",
    checked:"",
    labelClass:"pointer",
    value:"",
    hasLabel:true
};


export default CheckBox;
